import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TasksService } from 'src/app/shared/services/task-service/tasks.service';
import { UtilsService } from 'src/app/shared/services/utils-service/utils.service';

@Component({
  selector: 'app-task-template-list',
  templateUrl: './task-template-list.component.html',
  styleUrls: ['./task-template-list.component.scss']
})
export class TaskTemplateListComponent implements OnInit {

  templatelist:any[] = [];
  templatelistData:any[] = [];
  customTemplate: any;
  @Output("selectedCheckList") selectedCheckList = new EventEmitter();
  @Input("project_id") project_id:any;

  constructor(
    public taskService:TasksService,public utils:UtilsService
    ) { }

  async ngOnInit(){
    await this.getTemplateList();
  }

  async getTemplateList(){
    (await this.taskService.getAllUsersTemplateList(this.project_id ? this.project_id : null)).subscribe((res:any)=>{
      if(res?.result){
        this.customTemplate =  JSON.parse(JSON.stringify([...res?.result]));
      }
    });
  }

  checkSelected(_status: any, value: any) {
    this.customTemplate.forEach((element: any) => {
      if (element._id == value._id) {
        if (value.checked) {
          element["checked"] = true;
        } else {
          element["checked"] = false;
        }
      } else {
        element["checked"] = false;
      }
    });
    this.templatelistData = this.customTemplate.filter(
      (item: any) => item.checked === true
    );
  }

  checkedChecklist() {
    this.selectedCheckList.emit(JSON.parse(JSON.stringify(this.templatelistData)));
    setTimeout(() => {
      this.customTemplate.forEach((element: any) => {
        element.checked = false;
      });
      this.templatelistData = [];
    }, 100);
  }

}
